import {
  Button,
  Flex,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Progress,
  ProgressLabel,
  TagLabel,
  Text,
} from "@chakra-ui/react";
import React from "react";
import loadingGif from "../Icons/loading.gif";

const LoadingModal = ({
  isOpen,
  onClose,
  title,
  text,
  imageSrc,
  progressPercent,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="3xl">
      <ModalOverlay
        bg="blackAlpha.300"
        backdropFilter="blur(10px) hue-rotate(30deg)"
      />
      <ModalContent>
        <ModalCloseButton />
        <ModalBody>
          <Flex justifyContent="center" alignItems="center">
            <Image
              src="https://i.ibb.co/P1DCVSv/ripik-trademark-logo.png"
              w="65%"
            />
            <Image h="100px" w="100px" src={loadingGif} />
          </Flex>
          <Flex direction="column" gap="1rem" align="center" justify="center">
            <Text fontSize="17px" fontWeight="bold">
              Optimus at work...
            </Text>
            <Text>{text}</Text>
          </Flex>
          <Progress
            hasStripe
            value={progressPercent || 0}
            h="20px"
            direction="right"
            mt="1rem"
            mb="1rem"
            colorScheme="linkedin"
            isAnimated={() => true}
            borderRadius="10px"
          >
            <ProgressLabel
              fontSize="sm"
              fontWeight="700"
              position="absolute"
              left="50%"
              transform="translate(-50%, -50%)"
              color="black"
            >
              {(progressPercent || 0) + "%"}
            </ProgressLabel>
          </Progress>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default LoadingModal;
